import { Epic } from "redux-observable";
import { switchMap, filter } from "rxjs/operators";
import { Observable } from "rxjs";
import { IState, Dependencies } from "../@types";
import { RootAction } from "../actions";
import { isActionOf } from "typesafe-actions";
import { usersActions, usersActionsAsync } from "../actions/usersActions";
import { appActions } from "../actions/appActions";
import { Auth } from "aws-amplify";


export const createUserEpic: Epic<
    RootAction,
    RootAction,
    IState,
    Dependencies
> = (action$, state$, dependencies) => {
    return action$.pipe(
        filter(isActionOf(usersActionsAsync.createUser.request)),
        switchMap(action => {
            return new Observable<RootAction>(observer => {
                const state = state$.value as IState;
                const { apiGatewayUrl } = state.constants;
                const { user, password } = action.payload;
                async function createUser() {
                    const session = await Auth.currentSession();
                    const token = session.getIdToken().getJwtToken();

                    const newUser = await dependencies.usersApi.createUser({
                        apiGatewayUrl,
                        token,
                        user,
                        password
                    });
                    observer.next(usersActionsAsync.createUser.success({ user: newUser }));
                }
                createUser().catch(error => {
                    console.log(error);
                    observer.next(usersActionsAsync.createUser.failure({ error }));
                    observer.next(appActions.setMessage({ message: error, severity: "error" }))
                });
            });
        })
    );
}